import axios from "axios";
import { BASE_URL } from "@config/variables";

/**
 * Service Request API Service
 * Centralized API calls for service requests (queries)
 */

/**
 * Get all query details for the current user
 * @returns {Promise<Object>} Response with query details
 */
export const getQueryDetails = async () => {
  const options = {
    url: `${BASE_URL}/services/apexrest/QueryDetails/`,
    method: "get",
  };

  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.QueryDetails || [],
      };
    }
    throw new Error("Failed to fetch query details");
  } catch (error) {
    const errorMessage = error?.response?.data?.[0]?.message || 
                         (error?.code === "ERR_NETWORK" ? "Network error" : "Something went wrong");
    return {
      success: false,
      error: errorMessage,
    };
  }
};

/**
 * Get query update history for a specific record
 * @param {string} recId - Record ID
 * @returns {Promise<Object>} Response with query update history
 */
export const getQueryUpdateHistory = async (recId) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/Query_Update/`,
    method: "post",
    data: { recId },
  };

  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
      };
    }
    throw new Error("Failed to fetch query updates");
  } catch (error) {
    const errorMessage = error?.code === "ERR_NETWORK" 
      ? "Network error" 
      : "Something went wrong";
    return {
      success: false,
      error: errorMessage,
    };
  }
};

/**
 * Get uploaded file information for a query
 * @param {string} id - Query ID
 * @returns {Promise<Object>} Response with file details
 */
export const getUploadedFileInfo = async (id) => {
  const options = {
    url: `${BASE_URL}/services/data/v56.0/query?q=SELECT ContentDocument.Title, ContentDocument.LatestPublishedVersionId FROM ContentDocumentLink WHERE LinkedEntityId = '${id}'`,
    method: "get",
  };

  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.records || [],
      };
    }
    throw new Error("Failed to fetch uploaded file info");
  } catch (error) {
    return {
      success: false,
      error: error?.code === "ERR_NETWORK" ? "Network error" : "Something went wrong",
    };
  }
};

/**
 * Download file from Salesforce
 * @param {string} versionId - Content Version ID
 * @param {string} accessToken - Salesforce access token
 * @returns {Promise<Blob>} File blob
 */
export const downloadFile = async (versionId, accessToken) => {
  const url = `https://pidilitecwp.my.salesforce.com/services/data/v56.0/sobjects/ContentVersion/${versionId}/VersionData`;

  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.blob();
};
